export default names => {
  const actionTypes = {}
  Object.keys(names).forEach(name => {
    actionTypes[name] = name
  })
  return actionTypes
}


// WEBPACK FOOTER //
// ./src/utils/generateActionTypeNames.js